import React from 'react'
import PropTypes from 'prop-types'
import {Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {useIntl} from 'react-intl'

const VatLabel = ({
    amount,
    variant,
    price,
    vatRate,
    hideVatRate = false,
    fixedCurrency,
    ...props
}) => {
    let vatAmount = amount || price - price / (1 + vatRate / 100)
    const included = !vatRate && !amount
    const {currency} = useCurrency()

    const styles = useMultiStyleConfig('VatLabel', {variant})
    const intl = useIntl()
    const fixedVatRate = vatRate ? Math.round(vatRate) : 0

    if (!included)
        vatAmount = intl.formatNumber(vatAmount, {
            style: 'currency',
            currency: fixedCurrency || currency,
            currencyDisplay: 'narrowSymbol',
        })

    let label
    if (included) {
        label = intl.formatMessage({
            id: 'vat_label.included',
            defaultMessage: '*VAT Included',
        })
    } else if (hideVatRate) {
        label = intl.formatMessage(
            {
                id: 'vat_label.amount_no_rate',
                defaultMessage: 'Included VAT amount of {vatAmount}',
            },
            {vatAmount},
        )
    } else {
        label = intl.formatMessage(
            {
                id: 'vat_label.amount',
                defaultMessage: 'Included VAT amount of {vatAmount} ({vatRate}%)',
            },
            {vatAmount, vatRate: fixedVatRate},
        )
    }

    return (
        <Text as="p" {...styles.ivaText} {...props} data-testid="vat-label">
            {label}
        </Text>
    )
}

VatLabel.propTypes = {
    amount: PropTypes.number,
    variant: PropTypes.string,
    price: PropTypes.number,
    vatRate: PropTypes.number,
    fixedCurrency: PropTypes.string,
    hideVatRate: PropTypes.bool,
}
export default VatLabel
